import React from "react";

export default function Privacy() {

    return (
        <div className="w-full min-h-screen bg-white text-black px-6 py-8 md:px-16 lg:px-24">

            <div className="mb-6 leading-relaxed text-[16px]">
                <p>
                    Website:{" "}
                    <a
                        href="https://redvideochat.live/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-red-500"
                    >
                        https://redvideochat.live/
                    </a>
                </p>
                <p>
                    Terms Of Use:{" "}
                    <a
                        href="/terms"
                        className="text-red-500"
                    >
                        https://redvideochat.live/terms
                    </a>
                </p>
            </div>

            {/* PRIVACY CONTENT */}
            <div className="leading-7 text-[16px] whitespace-pre-line">

                <p className="font-semibold">Introduction</p>

                <p>
                    This is the Privacy Policy of Red Video Chat and is incorporated into and is subject
                    to our Terms of Use which can be found at{" "}
                    <a
                        href="https://redvideochat.live/terms"
                        target="_blank"
                        rel="noreferrer"
                        className="text-red-500"
                    >
                        https://redvideochat.live/terms
                    </a>
                </p>

                <p>
                    In this Privacy Policy, we refer to our products and services as the “Service.”
                    Please read on to learn more about our data handling practices. Your use of
                    the Service signifies that you agree with the terms of this Privacy Policy.
                    If you do not agree with the terms of this Privacy Policy, do not use the
                    Service.
                </p>

                <br />

                <p className="font-semibold">Information we collect</p>

                <p>
                    When you install the Service on your device and register with Red,
                    personally identifiable information about you may be collected during the
                    download process for the Service (as requested from you during the download
                    process) when you register with us. For registration through Red, you are
                    required to provide your mobile phone number or your email address, city
                    location, gender, name, depending on the device(s) you are using on the
                    Service. You may also provide personally identifiable information, but that
                    is optional. When you log in using your Facebook account, we may collect
                    additional information you make available to us (see “Your User Profile”)
                    below.
                </p>

                <br />

                <p>
                    In addition, when you install the Service on your device and register with
                    Red, you may will be asked to allow us access to your address book. If you
                    consent, we will have access to contact information in your address book on
                    the devices you use for the Service (names, numbers, emails, and Facebook ID,
                    but not notes or other personal information in your address book) and we will
                    store it on our servers and use it to help you use the Service, for example,
                    by synchronizing your Red contacts between different devices you may want
                    to use with the Service. If you do not want Red to store this information,
                    you may opt-out through your account settings in the Red application at any
                    time. However we may not be able to offer some of the features that require
                    this information.
                </p>

                <br />

                <p>
                    Red may also collect and gather non-personally identifiable information,
                    such as certain profile information including country of residence and
                    preferences. In addition, Red may collect and store information about your
                    and others’ usage of and interaction with the Service and our websites,
                    including matches, numbers of matches made by members, match durations,
                    text messages, usage by geographies, device and connection information,
                    IP address, device capability, bandwidth, statistics on page views, network
                    type and traffic to and from our websites.
                </p>

                <br />

                <p>
                    Red allows you to share text messages, photos, screenshots, videos and other
                    communications in the Red application with other users, and if you choose to
                    do so your text messages, photos, screenshots, videos and other communications
                    will be stored on our servers. In addition, if you choose to share these items
                    with other Red users, we may not be able to remove them from our servers or
                    make them unavailable to anyone you have shared them with. Sending and sharing
                    text messages, photos, screenshots, videos or other communications in the Red
                    application is your decision. By choosing to share that information, you should
                    understand that you may no longer be able to control how that information is
                    used and that it may become publicly available (depending in part on your
                    actions or the actions of others with Red you have shared the information).
                    Red is not responsible for any use or misuse of information you share.
                </p>

                <br />

                <p>
                    Red may also collect and gather user contents (e.g., photos, screenshots,
                    comments, and other materials) that you create on the Service. Your photo can
                    be taken by other users on the Red, and If they use capturing function
                    provided by the Red, those photos can be stored and used for Red and 3rd
                    party’s service(eg, Facebook, etc.). You can change sharing option of 3rd
                    party on the Red settings. If you do not agree with all the terms of this
                    Privacy Policy, do not use the Service.
                </p>

                <br />

                <p>
                    To complete a commerce transaction on Red item shop, you will be requested
                    to provide your payment information, including your credit card number, card
                    expiration date, CVV code, and billing address. In that event, we will
                    transmit your information securely directly to a third party vendor or
                    merchant Red will collect such information in order to process and fulfill
                    your purchase. Red does not process or store your payment information.
                    However, we may store other information about your purchases made on the
                    Service, which may include the merchant’s name, the date, time and amount of
                    the transaction and other behavioral information.
                </p>

                <br />

                <p>
                    We also collect error-reporting information if the Service crashes or hangs
                    up so that we can investigate the error and improve the stability of the
                    Service for future releases. In general these reports do not contain
                    personally identifiable information, or only incidentally. As part of these
                    error reports, we receive information about the type and version of your
                    device, the device identifier, the time the error occurred, the feature being
                    used and the state of the application when the error occurred. We do not use
                    this information for any purpose other than investigating and fixing the error.
                </p>

                <br />

                <p className="font-semibold">Sharing of your information</p>

                <p>
                    We will not rent or sell your information to third parties (or the group of
                    companies of which Red is a part) without your consent, except as noted in
                    this Policy.
                </p>

                <br />

                <p className="font-semibold">Parties with Red we may share your information:</p>

                <p>
                    We may share User Content and your information (including but not limited to,
                    information from cookies, log files, device identifiers, location data, and
                    usage data) with businesses that are legally part of the same group of
                    companies that Red is part of, or that become part of that group
                    ("Affiliates"). Affiliates may use this information to help provide,
                    understand, and improve the Service (including by providing analytics) and
                    Affiliates' own services (including by providing you with better and more
                    relevant experiences). But these Affiliates will honor the choices you make
                    about Red can see your contents.
                </p>

                <ul className="list-disc ml-5">
                    <li>
                        We may share User Content and your information (including but not limited
                        to, information from cookies, log files, device identifiers, location
                        data, and usage data) with businesses that are legally part of the same
                        group of companies that Red is part of, or that become part of that group
                        ("Affiliates"). Affiliates may use this information to help provide,
                        understand, and improve the Service (including by providing analytics)
                        and Affiliates' own services (including by providing you with better and
                        more relevant experiences). But these Affiliates will honor the choices
                        you make about Red can see your contents.
                    </li>
                    <li>
                        We also may share your information as well as information from tools
                        like cookies, log files, and device identifiers and location data, with
                        third-party organizations that help us provide the Service to you
                        ("Service Providers"). Our Service Providers will be given access to
                        your information as is reasonably necessary to provide the Service under
                        reasonable confidentiality terms.
                    </li>
                    <li>
                        We may also share aggregate or anonymous information with third parties,
                        including advertisers and investors. For example, we may tell our
                        advertisers the number of users our app receives. This information does
                        not contain any personal or personally identifiable information, and is
                        used to develop content and services that we hope you will find of interest.
                    </li>
                    <li>
                        We may remove parts of data that can identify you and share anonymized
                        data with other parties. We may also combine your information with
                        other information in a way that it is no longer associated with you and
                        share that aggregated information.
                    </li>
                </ul>

                <br />

                <p className="font-semibold">Parties with Red you may choose to share your User Content:</p>

                <ul className="list-disc ml-5">
                    <li>
                        Any information or content that you voluntarily disclose for posting to
                        the Service, such as User Content, becomes available to the public. With
                        this feature, Red can be protected from exhibitionism. Once you have
                        shared User Content or made it public, that User Content may be re-shared
                        by others.
                    </li>
                    <li>
                        If you remove information and contents(eg. Screenshots, etc.) that you
                        created on the Service, copies may remain viewable in cached and archived
                        pages of the Service, or if other Users or third parties have copied or
                        saved that information.(eg. Facebook, etc.)
                    </li>
                </ul>

                <br />

                <p className="font-semibold">How we use information we collect</p>
                <p>We use or may disclose your personal information only as follows:</p>

                <ul className="list-disc ml-5">
                    <li>To verify your identity;</li>
                    <li>To connect you with others as enabled by the Service;</li>
                    <li>To share your Profile with others on the Service; </li>
                    <li>
                        To allow your use of certain features of the Service that may be offered
                        from time to time (such as Premium Services (see our Terms of Use), etc.);
                    </li>
                    <li>
                        To show you the names of persons you communicate with and to show your
                        name to persons you communicate with on the Service;
                    </li>
                    <li>
                        To deliver to you any administrative notices, alerts and communications
                        relevant to your use of the Service;
                    </li>
                    <li>
                        To provide you with relevant content that you requested, using
                        information that you allow us to collect from you or that you provide
                        to a social media provider with which your Red account is connected,
                        such as information regarding your and your Red contacts' respective
                        locations;
                    </li>
                    <li>
                        To contact you via email, SMS or otherwise for the purpose of informing
                        you about new products, services or promotions offered by Red
                    </li>
                    <li>
                        For internal operations, including troubleshooting problems, data analysis,
                        testing, research, improvements to the Service, detecting and protecting
                        against error, fraud or other illegal activity;
                    </li>
                    <li>
                        When we have a good faith belief that the law, any legal process, law
                        enforcement, national security or issue of public importance requires
                        disclosure;
                    </li>
                    <li>
                        To protect and defend our rights or property (including to enforce our
                        Terms of Use and other agreements); or
                    </li>
                    <li>
                        In connection with a corporate transaction involving Red, such as the
                        purchase or sale of a business unit, an acquisition, merger, sale of
                        assets, or other similar event.
                    </li>
                </ul>

                <br />

                <p className="font-semibold">Your User Profile</p>
                <p>
                    The information you enter into your user profile (your “Profile”) may be
                    shared with your Red contacts. You control your Profile and you can access
                    and modify your Profile from the Red application at any time. In addition,
                    if you register with Red using your Facebook account (e.g. Facebook Connect),
                    we may store your Facebook ID and corresponding token on our servers and, if
                    you give us your express consent, we will have access to and may collect
                    certain information that you make available on Facebook (for example, your
                    first and last names, email address, profile picture, your friend lists and
                    birthdays). Your Profile is available to other users of the Service Red are
                    connected to you on Red. In addition, unless you opt-out (which you may do
                    at any time in the Red application), your Profile is discoverable by other
                    Red users, including by way of example in listings of contacts that will
                    include your proximity to other users. You may also “block out” any Red user
                    in your contact list from discovering your Profile at any time. In addition,
                    Red may pre-populate your Profile with certain information such as your name
                    and Facebook profile picture if you or your friends have logged onto the
                    Service using Facebook.
                </p>

                <br />

                <p className="font-semibold">Data Access and Removal</p>
                <p>
                    You can always control what information you choose to share with us on the
                    Service. To do so, you can change your settings in the Service or in your
                    mobile device. Alternatively, you can remove the Service from your mobile
                    device entirely.
                </p>

                <br />

                <p>
                    You can remove your data anytime you want. If you ask us to delete your
                    account, we will use commercially reasonable efforts to remove your data
                    from our servers.
                </p>

                <br />

                <p>
                    Any personally identifiable information that (i) you share in text messages,
                    photos, videos or otherwise in or through the Red application with other
                    users, or (ii) submit on a blog, bulletin board or chat room on our website
                    or elsewhere, can be viewed and used by others, including to send you
                    unsolicited messages or to commit identity theft. Red is not responsible
                    for any use or misuse of your information that might result from your
                    disclosure of information.
                </p>

                <br />

                <p className="font-semibold">Service Providers</p>
                <p>
                    In certain instances, Red Video Chat may have contracts with third parties
                    to provide products and/or services in connection with the Service. In those
                    cases, Red may share your personal information with Red's third-party
                    service providers, but only in connection with providing the services to you.
                    For example, Red shares your phone number or email with third party SMS and
                    email providers to deliver the authentication SMS or email to you when you
                    register with Red. We contractually require that these third parties use your
                    information solely to deliver SMS or email to you and to use appropriate
                    security measures to protect your information. In addition, certain Red
                    servers are owned and hosted by third party service providers.  Our website
                    uses the Microsoft Clarity service to improve user experience. This service
                    collects anonymous data about user interactions such as page visits, clicks,
                    and navigation movements. Cookies are used during the use of Microsoft Clarity
                    and the data obtained through these cookies is used for analysis purposes only.
                    Users can update or reject cookie settings at any time.  This Privacy Policy
                    does not apply to the practices of third party service providers.
                </p>

                <br />

                <p className="font-semibold">Outbound Links</p>
                <p>
                    If you accessed a website, product or service provided by a third party,
                    including through the Service or a Red website, such third party may also
                    collect information about you. Please see the privacy policies of each such
                    third party for more information about how they use the information they
                    collect. This Privacy Policy does not apply to any exchange of information
                    between you and any third party.
                </p>

                <br />

                <p className="font-semibold">Opt-Out – Promotional Communications</p>
                <p>
                    Red allows you to choose not to receive promotional email messages from
                    Red and its service providers. You may opt-out by following instructions
                    in the message sent by Red or its service providers on how to unsubscribe
                    from that particular mailing.
                </p>

                <br />

                <p className="font-semibold">Security</p>
                <p>
                    Protecting user privacy and personal information is a top priority for Red
                    Video Chat. We make substantial efforts to ensure the privacy of all personally
                    identifiable information you provide to us. Access to all personally
                    identifiable information is restricted to Red Video Chat employees,
                    contractors, agents and third-party service providers Red need to know that
                    information in order to provide, operate, develop, maintain, support or improve
                    the Service. Red Video Chat uses password protection, access logs, and system
                    monitoring to safeguard the confidentiality and security of all member
                    information.
                </p>

                <br />

                <p>
                    In addition, due to the inherent nature of the Internet and related technology,
                    we do not guarantee the protection of information under our control against
                    loss, misuse or alteration.
                </p>

                <br />

                <p className="font-semibold">Data Transfer</p>
                <p>
                    Your information may be stored and processed in any country in which
                    Red Video Chat maintains facilities, including outside of the South Korea.
                    In this regard, or for purposes of sharing or disclosing data as described in
                    this Privacy Policy, Red Video Chat reserves the right to transfer information
                    outside of your country. By using the Service, you consent to any such transfer
                    of information outside of your country.
                </p>

                <br />

                <p className="font-semibold">Age</p>
                <p>
                    The Service is not directed to children under the age of eighteen (18) and we
                    do not knowingly collect personally identifiable information from children
                    under the age of eighteen as part of the Service. If we become aware that we
                    have inadvertently received personally identifiable information from a user
                    under the age of eighteen as part of the Service, we will delete such
                    information from our records. If we change our practices in the future, we
                    will obtain prior, verifiable parental consent before collecting any personally
                    identifiable information from children under the age of eighteen as part of the
                    Service.
                </p>

                <br />

                <p className="font-semibold">Notifications Of Changes</p>
                <p>
                    We reserve the right at our discretion to make changes to this Privacy Policy.
                    You may review updates to our Privacy Policy at any time via links on our
                    website. You agree to accept electronic communications and/or postings of a
                    revised Privacy Policy on the Red Video Chat web site, and you agree that such
                    electronic communications or postings constitute notice to you of the Privacy
                    Policy. We reserve the right to modify this policy from time to time, so please
                    review it frequently.
                </p>

                <br />
                
                <p>
                    If we make material changes to this policy, we will notify you by publishing a
                    revised Privacy Policy or by means of a notice on our website, or as required
                    by law. You agree to review the Privacy Policy periodically so that you are
                    aware of any modifications. You agree that your continued use of the Service
                    after we publish a revised Privacy Policy or provide a notice on our website
                    constitutes your acceptance of the revised Privacy Policy. If you do not agree
                    with the terms of the Privacy Policy, you should not use the Service.
                </p>

                <br />

                <p className="font-semibold">Contact information</p>
                <p>
                    If you have any questions about this Privacy Policy, please contact us. Any 
                    personally identifiable information provided in connection with inquiries 
                    related to this Privacy Policy will be used solely for the purpose of 
                    responding to the inquiry and consistent with our Privacy Policy.
                </p>

            </div>

        </div>
    );
}